export const selectCommentsForRecording = (comments, recording) => {
  const selected = [];
  recording.comments.forEach((id) => selected.push(comments.hash[id]));
  return selected;
};
